import React, { useState, useEffect } from 'react'
import Select from "react-select";
import { useParams } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import { TbLoader } from "react-icons/tb";
import { NumericFormat } from 'react-number-format';
import ListOptionsEstatus from '../../../../helpers/ListOptionsEstatus';
import { getAllContainers } from '../../../../helpers/Api';

const Demoras = ({ 
  idSolicitud, 
  totalDemoras, 
  setQuery, 
  query,
}) => {

  const params = useParams(); 
  const token = localStorage.getItem('token');
  const [loading, setLoading] = useState(true);
  const [containersData, setContainersData] = useState([]);
  //SEARCH
  const [containerNumber, setContainerNumber] = useState('')
  const [containerStatus, setContainerStatus] = useState('');
  const [solicitudesPendientes, setSolicitudesPendientes] = useState(0);

    //pagination
    const itemsPerPage = 10;
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    getContainers();
    //this query helps to refresh total a pagar
    setQuery(query +1);
  }, [
    containerNumber,
    containerStatus,
    itemOffset,
    ])


  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  const handlerContainerNumber = (e) => {
    setContainerNumber(e.target.value);
  };

  const handlerContainerStatus = (e) => {
    setContainerStatus(e === null ? '' : e.value);
  };


  const getContainers = async () => {
    try {
      const response = await getAllContainers(
        itemsPerPage, 
        itemOffset, 
        idSolicitud || params.id,
        containerNumber, 
        containerStatus, 
        token);
      if (response) {
        response?.count === itemsPerPage
        ? setPageCount(1)
        : setPageCount(Math.ceil(response?.count / itemsPerPage));
        setContainersData(response.results);
        setSolicitudesPendientes(response?.count);
      }
    } catch (error) {
      throw error
    } finally {
      setLoading(false);
    }
  };


    return (
      <>
    { loading ? (
      <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
            <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
        </div>
        ) : (
      <>
      <div className="row mb-4 mt-2">
        <div className="col-3">
          <form className="d-flex">
            <input
              className="form-control"
              type="search"
              onChange={handlerContainerNumber}
              value={containerNumber}
              placeholder="Número de contenedor"
              aria-label="Search"
              style={{ width: "100%" }}
            />
          </form>
        </div>
        <div className="col-4">
        <Select
            className="basic-single"
            classNamePrefix="select"
            options={ListOptionsEstatus}
            onChange={(e) => handlerContainerStatus(e)}
            placeholder={"Filtro por estatus"}
            isClearable={true}  
          />
        </div>
      </div>
        
      <div className="row d-flex justify-content-center">
      <div className="col-12 table-responsive">
        <table className="table mt-4">
          <thead>
            <tr>
              <th scope="col">No. Contenedor</th>
              <th scope="col">Días de demoras generadas</th>
              {/*
              <th scope="col">Cantidad unitaria USD</th>
              */}
              <th scope="col">Total USD</th>
            </tr>
          </thead>
          { containersData.map((value, index) => (
          <tbody key={index}>
            <tr>
              <td style={{ paddingTop: "14px" }}>{value?.numero}</td>
              <td style={{ paddingTop: "14px" }}>{value?.dias_demoras}</td>
              {/*
              <td style={{ paddingTop: "14px" }}>
              <NumericFormat 
                prefix={"$"} suffix={" USD"}  
                decimalSeparator={"."}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                displayType="text" 
                value={value?.cantidad_demoras_dias} 
                />
              </td>
              */}
              <td style={{ paddingTop: "14px" }}>
              <NumericFormat 
                prefix={"$"} suffix={" USD"}  
                decimalSeparator={"."}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
                displayType="text" 
                value={value?.total_demoras} 
                />
              </td>
            </tr>   
          </tbody>
          ))}
        </table>
      </div>
      <div className='col-10 mt-5 d-flex flex-row-reverse'>
      { !(containerNumber || containerStatus) &&
      <>
        <NumericFormat 
          prefix={"$"} suffix={" USD"}  
          decimalSeparator={"."}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          displayType="text" 
          value={totalDemoras} 
          />
          <p>Cantidad total de Demoras: &nbsp;</p>
      </>    
      }
      </div>
      <div className="row">
        <div className="col-12" style={{textAlign: 'center', marginTop: '2rem'}}>
            <p>Total de demoras: {solicitudesPendientes}</p>
          </div>
          <div className="col-12 d-flex justify-content-end paginationList">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Siguiente"
              onPageChange={handlePageClick}
              pageRangeDisplayed={10}
              pageCount={pageCount}
              previousLabel="Anterior"
              renderOnZeroPageCount={null}
              containerClassName="pagination my-5 mx-auto"
              subContainerClassName="pages pagination"
              activeClassName="active"
              breakClassName="break-me"
              className="pagination"
            />
          </div>
        </div>
    </div>
    </>
    )}
    </>
    )
  }
  
  export default Demoras